import { createAsyncThunk } from '@reduxjs/toolkit'
import { getExternalPrices } from 'api/v1/prices'
import { SymbolName } from 'types'

export const getExternalPricesAction = createAsyncThunk<
  Record<SymbolName, number> // { "WBTC": 50000.0 }
>('market/getExternalPricesAction', async () => {
  return await getExternalPrices()
})
